import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../routes'
import { rolesAndPermissions } from '../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { FormLoader } from '../../components/Loader/FormLoader'
import RolesContent from '../../components/Dashboard/RolesContent'


const Roles = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.RolesAndPermissions' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={rolesAndPermissions.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.RolesAndPermissions' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<RolesContent handleNotificationCall={handleNotificationCall}
                                               adminSectionType={adminSectionType}/>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Roles

